const selectors = [
  '.product-options__descriptions [data-option-id]',
  '.product-option[data-option-id]'
]

export function selectProductOption(root, optionId, modal) {
  if (!root || !optionId) {
    return false
  }
  const toogleClasses = (item) => {
    if (item.dataset.optionId.toUpperCase() === optionId.toUpperCase()) {
      item.classList.add('is-active')
    } else {
      item.classList.remove('is-active')
    }
  }

  selectors.forEach((selector) => {
    root.querySelectorAll(selector).forEach(toogleClasses)
  })

  document.querySelectorAll('[data-product-option-render]').forEach((node) => {
    node.textContent = optionId.toUpperCase()
  })
  root.dataset.currentOption = optionId

  if (modal) {
    modal.modalEl.querySelectorAll('.product-option').forEach(toogleClasses)
  }
}
